import { NvCombobox, NvForm } from '@simwood/nv-react-components';
import React from 'react';

import { Control, FieldPath } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { setCallerId } from '../../reducers/client';
import { StoreDispatch, StoreState } from '../../store';
import * as styles from './styles.module.scss';

interface Props<TFieldValues extends { defaultCallerId: string | null }> {
  inline?: boolean;
  onlySmsCapable?: boolean;
  includeAnonymous?: boolean;
  labelText?: string;
  control?: Control<TFieldValues, any, TFieldValues>;
}

const CallerIdPicker = <
  TFieldValues extends { defaultCallerId: string | null },
>({
  inline,
  onlySmsCapable,
  includeAnonymous,
  labelText,
  control,
}: Props<TFieldValues>): React.JSX.Element => {
  const dispatch = useDispatch<StoreDispatch>();
  const clientSelectedCallerId = useSelector(
    (state: StoreState) => state.client.selectedCallerId,
  );
  const outgoingCallerIds = useSelector(
    (state: StoreState) => state.client.outgoingCallerIds,
  );

  const controlled = !!control;

  const doSetCallerId = (callerIdId: string | null) => {
    const callerId = outgoingCallerIds?.find((c) => c.id === callerIdId);
    if (!callerId) {
      return;
    }
    dispatch(setCallerId(callerId));
  };

  const callerIds =
    outgoingCallerIds
      ?.filter((x) => (onlySmsCapable ? x.allowSms : x.allowCalls))
      .map((x) => ({
        value: x.id,
        label: x.number,
      })) || [];

  if (!controlled) {
    return (
      <NvCombobox
        name='defaultCallerId'
        inline={inline}
        labelText={labelText}
        nullLabel={includeAnonymous ? 'Anonymous' : undefined}
        emptyLabel='Anonymous'
        className={inline ? styles.dropdown : undefined}
        items={callerIds}
        value={(clientSelectedCallerId && clientSelectedCallerId.id) || null}
        onChange={(selected) => {
          doSetCallerId(selected);
        }}
        searchEmptyLabel='No caller Ids found'
        searchPlaceholder='Search caller Ids'
      />
    );
  }

  return (
    <NvForm.Combobox
      control={control}
      name={'defaultCallerId' as FieldPath<TFieldValues>}
      required={!includeAnonymous}
      // rules={
      //   includeAnonymous
      //     ? undefined
      //     : {
      //         validate: (value) => {
      //           return (
      //             (value !== null && value !== undefined) ||
      //             'Please select a caller id'
      //           );
      //         },
      //       }
      // }
      items={callerIds}
      inline={inline}
      labelText={labelText}
      nullLabel={includeAnonymous ? 'Anonymous' : undefined}
      emptyLabel='Anonymous'
      className={inline ? styles.dropdown : undefined}
      searchEmptyLabel='No caller Ids found'
      searchPlaceholder='Search caller Ids'
    />
  );
};

const MemoizedCallerIdPicker = React.memo(
  CallerIdPicker,
) as typeof CallerIdPicker;

export default MemoizedCallerIdPicker;
